import type { poImports as enPoImports } from "../en/poImports";

// See en/poImports.ts for the note on `shared.tierGateSuffix` spacing — here
// the Italian word order puts "piano" before the never-translated "Pro" span,
// so the plan name is followed directly by punctuation with no leading
// space required (compare English's leading-space " tier.").
export const poImports: typeof enPoImports = {
  shared: {
    tierGatePrefix: "L'analisi PDF degli ordini d'acquisto è inclusa nel piano",
    tierGateSuffix: ".",
  },
  list: {
    uploadButton: "Carica un ordine d'acquisto",
    emptyBanner:
      "La tua Inbox PO è vuota. Carica il PDF dell'ordine d'acquisto di un acquirente e l'IA lo trasforma automaticamente in un ordine bozza pronto per la revisione, senza dover reinserire nulla a mano.",
    historyHeading: "Cronologia",
  },
  upload: {
    heading: "Carica un ordine d'acquisto",
    upgradeLink: "Esegui l'upgrade del tuo piano",
    tierRequiredError: "Il caricamento di ordini d'acquisto richiede il piano Pro.",
    noFileError: "Nessun file caricato.",
    notPdfError: "Sono supportati solo i file PDF.",
    fileTooLargeError: "PDF troppo grande ({{sizeMb}} MB) — il massimo è {{maxMb}} MB.",
    invalidPdfError: "Il file non sembra un PDF (intestazione %PDF mancante).",
    aiNotReady: {
      heading: "Funzionalità IA in attesa di configurazione.",
      body: "Il parser degli ordini d'acquisto richiede le credenziali di Trigger.dev e OpenRouter. Finché l'operatore non completa la configurazione, i PDF caricati restano in PENDING e non vengono mai analizzati.",
      envVarsPrefix: "(Imposta",
      envVarsAnd: "e",
      envVarsSuffix: "nell'ambiente di produzione.)",
    },
    openAiAssistantLink: "Apri l'Assistente IA",
    dropHeading: "Carica il tuo ordine d'acquisto",
    parseButton: "Analizza l'ordine d'acquisto",
    helperText: "Supporta PDF scansionati o fotografati. Le righe con affidabilità inferiore a 0,7 vengono segnalate per la revisione manuale.",
  },
  detail: {
    draftCreatedNotice: "Ordine bozza creato.",
    draftCreatedCatalogPriceNotice:
      "Ordine bozza creato — ma non è stato possibile determinare la valuta dell'ordine d'acquisto, quindi le righe sono state addebitate al prezzo di listino attuale. Verifica i prezzi prima di fatturare.",
    statusHeading: "Stato",
    parseCost: "costo di analisi ${{cost}}",
    parsingBanner: "Stiamo analizzando il PDF — aggiorna la pagina tra qualche secondo.",
    parsedLinesHeading: "Righe analizzate",
    qtyLabel: "qtà {{qty}}",
    confidenceLabel: "conf {{pct}}%",
    matchedFallback: "abbinato",
    unmatchedBadge: "non abbinato",
    createSectionHeading: "Crea ordine bozza",
    companyLabel: "Azienda",
    noCompaniesPrefix: "Nessuna azienda B2B trovata —",
    noCompaniesLink: "creane una qui in circa 20 secondi",
    noCompaniesSuffix: ", poi torna qui. Oppure incolla di seguito un GID azienda manualmente.",
    companyGidLabel: "GID azienda",
    companyGidHelpText: "Dall'amministrazione Shopify → Clienti → Aziende (l'URL lo contiene).",
    buyerEmailLabel: "Email dell'acquirente",
    createDraftOrderButton: "Crea ordine bozza",
    draftAlreadyCreatedButton: "Ordine bozza già creato",
    errors: {
      alreadyCreated: "Ordine bozza già creato per questo ordine d'acquisto importato.",
      pickCompany: "Seleziona prima un'azienda.",
      invalidCompanyGid: "L'ID azienda deve essere un GID Shopify (gid://shopify/Company/...).",
      invalidBuyerEmail: "Per creare l'ordine bozza è necessaria un'email valida dell'acquirente.",
      noMatchedLines: "Nessuna riga abbinata e disponibile in magazzino da cui creare un ordine bozza.",
      inFlight: "Creazione dell'ordine bozza già in corso per questo ordine d'acquisto importato. Attendi qualche istante e riprova.",
      createFailed: "Impossibile creare l'ordine bozza. Riprova.",
      creationFailedFallback: "Creazione dell'ordine bozza non riuscita.",
    },
  },
};
